module.exports = __webpack_public_path__ + "static/media/bankok_tailand.7359e874.jpg";